import { render, staticRenderFns } from "./paymenttochina-edit.vue?vue&type=template&id=70e1f4e4&scoped=true"
import script from "./paymenttochina-edit.vue?vue&type=script&lang=js"
export * from "./paymenttochina-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e1f4e4",
  null
  
)

export default component.exports